import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
// import { UtilsService } from '../../utils/common/utils.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-set-scheduler',
  templateUrl: './set-scheduler.component.html',
  styleUrls: ['./set-scheduler.component.css'],
  providers: [DatePipe]
})
export class SetSchedulerComponent implements OnInit {
  schedulerRadioValue = 'daily'; // 定时组件默认标签页
  schedulerDailyOccurrences = '1'; // 定时组件日默认值
  // schedulerDailyTimeValue = new Date(); // 定时组件时间默认值
  schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 天'; // 定时组件每日生成文本
  schedulerDateType = 'workdays';
  schedulerDateTypeText = '工作日';
  schedulerDayType = 'positive';
  schedulerDayTypeText = '正数';
  schedulerDayValue = '1';
  schedulerWeeklyOccurrences = '1'; // 定时组件周默认值
  // schedulerWeeklyTimeValue = new Date(); // 定时组件时间默认值
  schedulerWeeklyMergeText: string;
  schedulerWeeklyList: Array<any> = [
    {id: 1, label: '周一', select: false},
    {id: 2, label: '周二', select: false},
    {id: 3, label: '周三', select: false},
    {id: 4, label: '周四', select: false},
    {id: 5, label: '周五', select: false},
    {id: 6, label: '周六', select: false},
    {id: 7, label: '周日', select: false}
  ];
  schedulerWeeklyArray: Array<any> = [];
  schedulerMonthlyOccurrences = '1'; // 定时组件月默认值
  // schedulerMonthlyTimeValue = new Date(); // 定时组件时间默认值
  schedulerMonthlyMergeText: string;
  schedulerMonthlyList: Array<any> = [];
  schedulerMonthlyArray: Array<any> = [];
  dateTypes = [
    {label: '自然日', value: 'days'},
    {label: '工作日', value: 'workdays'}
  ];
  dayTypes = [
    {label: '正数', value: 'positive'},
    {label: '倒数', value: 'negative'}
  ];
  // 起始时间
  startDate = null;
  operate = null;
  // 非交易日
  holidayHandleWay = '1';
  holidayHandleWayText = '顺延';
  holidayHandleWayOperation = [
    {label: '顺延', value: '1'},
    {label: '提前', value: '2'},
    {label: '跳过', value: '0'}
  ];
  // 指定月
  months = [];
  monthsText = '';
  monthsOperation = [
    {label: '1月', value: '1'},
    {label: '2月', value: '2'},
    {label: '3月', value: '3'},
    {label: '4月', value: '4'},
    {label: '5月', value: '5'},
    {label: '6月', value: '6'},
    {label: '7月', value: '7'},
    {label: '8月', value: '8'},
    {label: '9月', value: '9'},
    {label: '10月', value: '10'},
    {label: '11月', value: '11'},
    {label: '12月', value: '12'}
  ];
  @Input() dateTypeEnable = false;
  @Input('nfData') set ChangeData(data: any) {
    if (data && JSON.stringify(data) !== '{}') {
      this.schedulerRadioValue = data.type;
      this.schedulerDateType = data.dateType;
      if (data.days && data.daysType !== 'normal') {
        this.schedulerDayType = data.daysType;
        this.schedulerDayValue = data.days.join(',');
      }
      this.schedulerDateTypeChange(this.schedulerDateType);
      if (this.schedulerRadioValue === 'daily') {
        this.schedulerDailyOccurrences = data.occurrences;
        this.schedulerDateType = data.dateType;
        this.schedulerDateTypeText = this.getDictionariesText(this.dateTypes, this.schedulerDateType);
        // this.schedulerDailyTimeValue = new Date(this.utilsService.formatDateByGeneral(new Date()) + ' ' + data.time);
        this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 天的 ' + data.time;
      } else if (this.schedulerRadioValue === 'weekly') {
        this.startDate = data.startDate ? data.startDate : null;
        if (data.days && data.days.length) {
          for (const weekDay of this.schedulerWeeklyList) {
            if (data.days.includes(weekDay.id)) {
              weekDay.select = true;
            }
          }
        }
        this.schedulerWeeklyMerge();
        this.schedulerWeeklyOccurrences = data.occurrences;
        this.holidayHandleWay = data.holidayHandleWay;
        this.holidayHandleWayText = this.getDictionariesText(this.holidayHandleWayOperation, this.holidayHandleWay);
        this.schedulerDayType = data.daysType;
        this.schedulerDayTypeText = this.getDictionariesText(this.dayTypes, this.schedulerDayType);
        this.schedulerDateType = data.dateType;
        this.schedulerDateTypeText = this.getDictionariesText(this.dateTypes, this.schedulerDateType);
        // this.schedulerWeeklyTimeValue = new Date(this.utilsService.formatDateByGeneral(new Date()) + ' ' + data.time);
      } else if (this.schedulerRadioValue === 'monthly') {
        this.startDate = data.startDate ? data.startDate : null;
        setTimeout(() => {
          if (data.days && data.days.length) {
            for (const day of this.schedulerMonthlyList) {
              if (data.days.includes(day.id)) {
                day.select = true;
              }
            }
          }
          this.schedulerMonthlyMerge();
        }, 200);
        this.schedulerMonthlyOccurrences = data.occurrences;
        this.holidayHandleWay = data.holidayHandleWay;
        this.holidayHandleWayText = this.getDictionariesText(this.holidayHandleWayOperation, this.holidayHandleWay);
        this.schedulerDayType = data.daysType;
        this.schedulerDayTypeText = this.getDictionariesText(this.dayTypes, this.schedulerDayType);
        this.schedulerDateType = data.dateType;
        this.schedulerDateTypeText = this.getDictionariesText(this.dateTypes, this.schedulerDateType);
        // this.schedulerMonthlyTimeValue = new Date(this.utilsService.formatDateByGeneral(new Date()) + ' ' + data.time);
      } else if (this.schedulerRadioValue === 'months') {
        this.months = data.months ? data.months : [];
        this.holidayHandleWay = data.holidayHandleWay;
        this.holidayHandleWayText = this.getDictionariesText(this.holidayHandleWayOperation, this.holidayHandleWay);
        this.schedulerDayType = data.daysType;
        this.schedulerDayTypeText = this.getDictionariesText(this.dayTypes, this.schedulerDayType);
        this.schedulerDateType = data.dateType;
        this.schedulerDateTypeText = this.getDictionariesText(this.dateTypes, this.schedulerDateType);
        this.monthsChange(this.months);
        setTimeout(() => {
          if (data.days && data.days.length) {
            for (const day of this.schedulerMonthlyList) {
              if (data.days.includes(day.id)) {
                day.select = true;
              }
            }
          }
          this.schedulerMonthlyMerge();
        }, 200);
      }
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    // private utilsModule: UtilsModule,
    // private utilsService: UtilsService,
    private message: NzMessageService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    // 定时初始化
    this.schedulerInit();
    if (this.dateTypeEnable) {
      this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 个 ' + this.schedulerDateTypeText;
    }
    if (this.schedulerRadioValue === 'weekly') {
      this.schedulerWeeklyMerge();
    }
    if (this.schedulerRadioValue === 'monthly') {
      this.schedulerMonthlyMerge();
    }
    if (this.schedulerRadioValue === 'months') {
      this.schedulerMonthlyMerge();
    }
  }

  schedulerInit() {
    for (let i = 1; i < 32; i++) {
      const obj = {
        'id': i,
        'label': i,
        'select': false
      };
      this.schedulerMonthlyList.push(obj);
    }
  }
  // 定时任务组件-radio切换
  schedulerRadioChange(event) {
    if (this.schedulerRadioValue === 'weekly') {
      this.schedulerWeeklyMerge();
    }
    if (this.schedulerRadioValue === 'monthly') {
      this.schedulerMonthlyList.forEach(item => {
        item.select = false;
      });
      this.schedulerMonthlyMerge();
    }
    if (this.schedulerRadioValue === 'months') {
      this.schedulerMonthlyList.forEach(item => {
        item.select = false;
      });
      this.schedulerMonthlyMerge();
    }
  }
  // 日期类型选择回调
  schedulerDateTypeChange(event) {
    for (const dateType of this.dateTypes) {
      if (dateType.value === this.schedulerDateType) {
        this.schedulerDateTypeText = dateType.label;
        break;
      }
    }
    if (event === 'workdays') {
      this.holidayHandleWay = null;
      this.holidayHandleWayText = '';
    }
  }
  schedulerDayTypeChange() {
    for (const dayType of this.dayTypes) {
      if (dayType.value === this.schedulerDayType) {
        this.schedulerDayTypeText = dayType.label;
        break;
      }
    }
  }
  // 定时任务组件-每周选择回调
  schedulerWeeklyTextChange(event) {
    event.select = !event.select;
    this.schedulerWeeklyMerge();
  }
  // 选中的周文字合并
  schedulerWeeklyMerge() {
    this.schedulerWeeklyArray = [];
    const weeklyText = [];
    this.schedulerWeeklyMergeText = '';
    this.schedulerWeeklyList.forEach((item, index) => {
      if (item.select) {
        this.schedulerWeeklyArray.push(item.id);
        weeklyText.push(item.label);
      }
    });
    this.schedulerWeeklyMergeText = weeklyText.join('，');
  }
  schedulerMonthlyTextChange(event) {
    event.select = !event.select;
    this.schedulerMonthlyMerge();
  }

  // 选中的月文字合并
  schedulerMonthlyMerge() {
    this.schedulerMonthlyArray = [];
    const labelData = [];
    this.schedulerMonthlyList.forEach((item, index) => {
      if (item.select) {
        this.schedulerMonthlyArray.push(item.id);
        labelData.push(item.id + '日');
      }
    });
    this.schedulerMonthlyMergeText = labelData.join('，');
  }
  // 提交定时
  schedulerOnSubmit() {
    let schedulerConfig = {};
    let schedulerConfigText = '';
    if (this.schedulerRadioValue === 'daily') {
      schedulerConfig = {
        'type': 'daily',
        'dateType': this.schedulerDateType,
        'occurrences': this.schedulerDailyOccurrences,
        // 'time': this.datePipe.transform(this.schedulerDailyTimeValue, 'HH:mm:ss')
      };
      schedulerConfigText = '每 ' + this.schedulerDailyOccurrences + (this.dateTypeEnable ?
        ' 个 ' + this.schedulerDateTypeText : ' 天');
    } else if (this.schedulerRadioValue === 'weekly') {
      if (this.schedulerWeeklyArray.length <= 0 && !this.schedulerDayValue) {
        this.message.warning('请选择每周的至少一天！');
        return;
      }
      if (this.schedulerWeeklyArray.length > 0) {
        schedulerConfig = {
          'type': 'weekly',
          'startDate': this.startDate,
          // 'occurrences': this.schedulerWeeklyOccurrences,
          'dateType': 'days',
          'days': this.schedulerWeeklyArray,
          'daysType': 'normal',
          'holidayHandleWay': this.holidayHandleWay
          // 'time': this.datePipe.transform(this.schedulerWeeklyTimeValue, 'HH:mm:ss')
        };
      } else if (this.schedulerDayValue) {
        schedulerConfig = {
          'type': 'weekly',
          'startDate': this.startDate,
          // 'occurrences': this.schedulerWeeklyOccurrences,
          'dateType': 'workdays',
          'daysType': this.schedulerDayType,
          'days': this.schedulerDayValue.split(','),
          'holidayHandleWay': this.holidayHandleWay
        };
      } else {
        schedulerConfig = {
          'type': 'weekly',
          'startDate': this.startDate,
          // 'occurrences': this.schedulerWeeklyOccurrences,
          // 'dateType': this.schedulerDateType,
          'daysType': 'normal',
          'holidayHandleWay': this.holidayHandleWay
          // 'time': this.datePipe.transform(this.schedulerWeeklyTimeValue, 'HH:mm:ss')
        };
      }
      if (this.schedulerWeeklyMergeText) {
        schedulerConfigText = (this.startDate ? '从' + this.startDate + '起，' : '') + '每' + (this.dateTypeEnable ?
          '周的 ' : ' 周的 ') + this.schedulerWeeklyMergeText + '，如遇非交易日 ' + this.holidayHandleWayText;
      } else {
        schedulerConfigText = (this.startDate ? '从' + this.startDate + '起，' : '') + '每' + (this.dateTypeEnable ?
          '周的 ' : ' 周的 ') + this.schedulerDayTypeText + ' ' + this.schedulerDayValue + ' 天，如遇非交易日 ' + this.holidayHandleWayText;
      }
      // if (this.schedulerWeeklyMergeText) {
      //   schedulerConfigText = '每 ' + this.schedulerWeeklyOccurrences + (this.dateTypeEnable ?
      //     ' 周 属于 ' + this.schedulerDateTypeText + ' 的 ' : ' 周的 ') + this.schedulerWeeklyMergeText;
      // } else {
      //   schedulerConfigText = '每 ' + this.schedulerWeeklyOccurrences + (this.dateTypeEnable ?
      //     ' 周 属于 ' + this.schedulerDateTypeText + ' 的 ' : ' 周的 ') + this.schedulerDayTypeText + ' ' + this.schedulerDayValue + ' 天';
      // }
    } else if (this.schedulerRadioValue === 'monthly') {
      if (this.schedulerMonthlyArray.length <= 0 && !this.schedulerDayValue) {
        this.message.warning('请选择每月的至少一天！');
        return;
      }
      if (this.schedulerMonthlyArray.length > 0) {
        schedulerConfig = {
          'type': 'monthly',
          'startDate': this.startDate,
          'occurrences': this.schedulerMonthlyOccurrences,
          'dateType': 'days',
          'days': this.schedulerMonthlyArray,
          'holidayHandleWay': this.holidayHandleWay,
          'daysType': 'normal'
        };
      } else if (this.schedulerDayValue) {
        schedulerConfig = {
          'type': 'monthly',
          'startDate': this.startDate,
          'occurrences': this.schedulerMonthlyOccurrences,
          'dateType': this.schedulerDateType,
          'daysType': this.schedulerDayType,
          'holidayHandleWay': this.holidayHandleWay,
          'days': this.schedulerDayValue.split(',')
        };
      } else {
        schedulerConfig = {
          'type': 'monthly',
          'startDate': this.startDate,
          'occurrences': this.schedulerMonthlyOccurrences,
          'dateType': this.schedulerDateType,
          'holidayHandleWay': this.holidayHandleWay,
          'daysType': 'normal'
          // 'time': this.datePipe.transform(this.schedulerMonthlyTimeValue, 'HH:mm:ss')
        };
      }
      if (this.startDate) {
        if (this.schedulerMonthlyMergeText) {
          schedulerConfigText = '从' + this.startDate + '起，每' + (this.dateTypeEnable ?
            '月的 ' : ' 月的 ') + this.schedulerMonthlyMergeText + '，如遇非交易日 ' + this.holidayHandleWayText;
        } else {
          schedulerConfigText = '从' + this.startDate + '起，每' + (this.dateTypeEnable ?
            '月属于 ' + this.schedulerDateTypeText + ' 的 ' : ' 月的 ') + this.schedulerDayTypeText + ' ' + this.schedulerDayValue + ' 天' + (this.schedulerDateType === 'workdays' ? '' : '，如遇非交易日 ' + this.holidayHandleWayText);
        }
      } else {
        if (this.schedulerMonthlyMergeText) {
          schedulerConfigText = '每' + (this.dateTypeEnable ?
            '月的 ' : ' 月的 ') + this.schedulerMonthlyMergeText + '，如遇非交易日 ' + this.holidayHandleWayText;
        } else {
          schedulerConfigText = '每' + (this.dateTypeEnable ?
            '月属于 ' + this.schedulerDateTypeText + ' 的 ' : ' 月的 ') + this.schedulerDayTypeText + ' ' + this.schedulerDayValue + ' 天' + (this.schedulerDateType === 'workdays' ? '' : '，如遇非交易日 ' + this.holidayHandleWayText);
        }
      }
    } else if (this.schedulerRadioValue === 'months') {
      if (this.months.length === 0) {
        this.message.warning('请选择至少一个月！');
        return;
      }
      if (this.schedulerMonthlyArray.length === 0) {
        this.message.warning('请选择至少一天！');
        return;
      }
      schedulerConfig = {
        'type': 'months',
        'months': this.months,
        'dateType': this.schedulerDateType,
        'daysType': this.schedulerDayType,
        'holidayHandleWay': this.holidayHandleWay,
        'days': this.schedulerMonthlyArray,
      };
      schedulerConfigText = this.monthsText + '属于' + this.schedulerDateTypeText + '的' + this.schedulerDayTypeText + this.schedulerMonthlyMergeText + (this.schedulerDateType === 'workdays' ? '' : '，如遇非交易日 ' + this.holidayHandleWayText);
    }
    // schedulerConfig['dateType'] = this.schedulerDateType;
    const schedulerConfigData = {
      'config': schedulerConfig,
      'text': schedulerConfigText
    };
    this.nfDataChange.emit(schedulerConfigData);
  }
  // 起始时间
  startDateOnChange(event) {
    this.startDate = this.datePipe.transform(event, 'yyyy-MM-dd');
  }
  // 非交易日
  holidayHandleWayChange(event) {
    if (event) {
      this.holidayHandleWayOperation.forEach(item => {
        if (item.value === this.holidayHandleWay) {
          this.holidayHandleWayText = item.label;
        }
      });
    } else {
      this.holidayHandleWay = event;
      this.holidayHandleWayText = '';
    }
  }
  // 指定月
  monthsChange(event) {
    if (event) {
      const monthsText = [];
      this.monthsText = '';
      event.forEach((item, index) => {
        this.monthsOperation.forEach(_m => {
          if (item === _m.value) {
            monthsText.push(_m.label);
          }
        });
      });
      this.monthsText = monthsText.join('，');
    }
  }
  // 根据字典Id查询Text
  getDictionariesText(data: Array<any>, id) {
    let text = null;
    data.forEach(item => {
      if (item.value === id) {
        text = item.label;
      }
    });
    return text;
  }
}
